const registry = new WeakMap();
const networkActionsEmptyForElCallbacks = [];
let globalCount = 0;

export function getPendingNetworkActionCount() {
	return globalCount;
}

export function pendingNetworkActionCountForHost(host) {
	return registry.has(host) ? registry.get(host).size : 0;
}

export function addPendingNetworkActionForHost(pendingNetworkAction, host) {
	if (!registry.has(host)) registry.set(host, new Set());
	registry.get(host).add(pendingNetworkAction);
	globalCount++;
}

export function removePendingNetworkActionForHost(pendingNetworkAction, host) {
	if (!registry.has(host)) return;
	registry.get(host).delete(pendingNetworkAction);
	globalCount--;
	const len = networkActionsEmptyForElCallbacks.length;
	for (let i = 0; i < len; i++) networkActionsEmptyForElCallbacks[i](host);
}

export function clearPendingNetworkActionsForHost(host) {
	if (!registry.has(host)) return;
	const networkActions = registry.get(host);
	globalCount -= networkActions.size;
	networkActions.clear();
}

export function addPendingNetworkActionForHostCb(fn) {
	networkActionsEmptyForElCallbacks.push(fn);
}

export function getHostPendingNetworkActionCount(host) {
	return (registry.has(host) && registry.get(host).size) || 0;
}
